import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Contributors
 * id 9CF3C6FF-4E68-478B-85B9-02ABA9A7980C
 * name numeric-1-box-multiple
 * version: 3.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-1-box-multiple.svg
 * tags
 * - Alpha / Numeric 
 */
export const Numeric1BoxMultipleIcon = createSvgIcon(<><path d="M3,5V21H19V23H3A2,2 0 0,1 1,21V5H3M21,1A2,2 0 0,1 23,3V17A2,2 0 0,1 21,19H7A2,2 0 0,1 5,17V3A2,2 0 0,1 7,1H21M14,15H16V5H12V7H14V15Z" /></>, 'Numeric1BoxMultipleIcon');
export default Numeric1BoxMultipleIcon